import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label, Input } from 'reactstrap';

const ModalVerCita = ({ isOpen, toggle, cita }) => {
  if (!cita) return null;

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>
        <i className="ri-calendar-line me-2"></i>
        Detalles de Cita - {cita.NUMERO || 'N/A'}
      </ModalHeader>
      <ModalBody>
        <FormGroup>
          <Label for="numero">Número de Cita</Label>
          <Input
            type="text"
            id="numero"
            value={cita.NUMERO || 'N/A'}
            disabled
          />
        </FormGroup>

        <div className="row">
          <div className="col-6">
            <FormGroup>
              <Label for="fecha">Fecha</Label>
              <Input
                type="text"
                id="fecha"
                value={cita.fecha || 'N/A'}
                disabled
              />
            </FormGroup>
          </div>
          <div className="col-6">
            <FormGroup>
              <Label for="hora">Hora</Label>
              <Input
                type="text"
                id="hora"
                value={cita.hora || 'N/A'}
                disabled
              />
            </FormGroup>
          </div>
        </div>

        <FormGroup>
          <Label for="patente">Patente</Label>
          <Input
            type="text"
            id="patente"
            value={cita.PATENT || 'N/A'}
            disabled
          />
        </FormGroup>

        <FormGroup>
          <Label for="cliente">Cliente (RUT)</Label>
          <Input
            type="text"
            id="cliente"
            value={cita.CLIENT || 'N/A'}
            disabled
          />
        </FormGroup>

        <FormGroup>
          <Label for="contacto">Contacto</Label>
          <Input
            type="text"
            id="contacto"
            value={cita.OBSER2 || 'N/A'}
            disabled
          />
        </FormGroup>

        <div className="row">
          <div className="col-6">
            <FormGroup>
              <Label for="email">Email</Label>
              <Input
                type="email"
                id="email"
                value={cita.MAICON || 'N/A'}
                disabled
              />
            </FormGroup>
          </div>
          <div className="col-6">
            <FormGroup>
              <Label for="telefono">Teléfono</Label>
              <Input
                type="text"
                id="telefono"
                value={cita.FONCON || 'N/A'}
                disabled
              />
            </FormGroup>
          </div>
        </div>

        <FormGroup>
          <Label for="tipo_trabajo">Tipo de Trabajo</Label>
          <Input
            type="text"
            id="tipo_trabajo"
            value={cita.TTRABA || 'N/A'}
            disabled
          />
        </FormGroup>

        <FormGroup>
          <Label for="solicitud">Solicitud del Cliente</Label>
          <Input
            type="textarea"
            id="solicitud"
            value={cita.OBSERV || 'N/A'}
            disabled
            rows="3"
          />
        </FormGroup>

        {cita.nrorecep && (
          <FormGroup>
            <Label for="nro_recepcion">Número de Recepción</Label>
            <Input
              type="text"
              id="nro_recepcion"
              value={cita.nrorecep}
              disabled
            />
          </FormGroup>
        )}
      </ModalBody>
      <ModalFooter>
        <button type="button" className="btn btn-secondary" onClick={toggle}>
          Cerrar
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default ModalVerCita;
